// import style from './terms.module.scss';
// import AppStore from "../../images/AppStore.png"
// import PlayStore from "../../images/PlayStore.png"
import termsAndCondition from '../../images/termsAndCondition.png';
import logoButton from '../../images/content.png';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import I18n from '../../lib/lingui/i18n';
import whatsApp from '../../images/iconWhatsapp.png';
import style from './terms.module.scss';
import buttom from '../../images/buttom.png';
import buttomMedia from '../../images/buttomMedia.png';
import logoPhonedo from '../../images/logoPhonedo.png';
import Cookies from 'universal-cookie';

export const PrivicyPolicy = () => {
  const history = useHistory();
  const [languageDirection, setLanguageDirection] = useState<string>();
  const [changeColor, setChangeColor] = useState<string>();

  useEffect(() => {
    if (
      window.location.pathname.includes('he') ||
      window.location.pathname.includes('ar')
    ) {
      setLanguageDirection('rtl');
    } else {
      setLanguageDirection('ltr');
    }
  }, []);
  return (
    <div>
      <div className={style.webSitebody}>
        <img
          className={style.firstBackround}
          src={termsAndCondition}
          alt={termsAndCondition}
        />
        <div
          className={style.section0}
          style={{ direction: languageDirection === 'rtl' ? 'rtl' : 'ltr' }}
        >
          <img
            className={
              languageDirection === 'rtl'
                ? style.rtllogoPhonedo.concat(' ').concat(style.logoPhonedo)
                : style.logoPhonedo
            }
            src={logoPhonedo}
            alt={logoPhonedo}
            onClick={() => {
              history.push('/');
            }}
          />
          <img
            className={
              languageDirection === 'rtl'
                ? style.logoButtonRtl
                : style.logoButton
            }
            src={logoButton}
            alt={'logoButton'}
            onClick={() => {
              history.push('/');
            }}
          />
          <div className={style.space}></div>
          {/* <button className={languageDirection === "rtl" ? style.buttonSignUpTermsRtl : style.buttonSignUpTerms} onClick={() => { history.push(`/${window.location.pathname.slice(1, 3)}/registration/verify-phone`) }}><I18n t="Sign Up" /></button> */}
        </div>
        <div className={style.section1}>
          <div
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.rapper)
                : style.rapper
            }
          >
            <div className={style.headerTerms}>
              <I18n t='Privacy Policy' />
            </div>
            {/* <div className={style.subheaderTerms}><I18n t="Privacy Policy-PhoneDo" /></div> */}
          </div>
        </div>
      </div>
      <div
        className={
          languageDirection === 'rtl'
            ? style.rtlLanguage.concat(' ').concat(style.flex)
            : style.flex
        }
        style={{ marginTop: '110px' }}
      >
        <div className={style.LeftSide}>
          <p className={style.round}>
            <div
              style={{ fontSize: '20px', lineHeight: '32px', height: '60px' }}
              className={style.title}
            >
              <I18n t='Terms of Service' />
            </div>
            <a
              href='#disclaimer-section'
              onClick={() => {
                setChangeColor('1');
              }}
              className={
                changeColor === '1' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='Last Updated on May 1, 2020' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#DEFINITIONS-section'
              onClick={() => {
                setChangeColor('2');
              }}
              className={
                changeColor === '2' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='DEFINITIONS' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#Business-section'
              onClick={() => {
                setChangeColor('3');
              }}
              className={
                changeColor === '3' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='Business' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#Company-section'
              onClick={() => {
                setChangeColor('4');
              }}
              className={
                changeColor === '4' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='Company' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#Freelancer-section'
              onClick={() => {
                setChangeColor('5');
              }}
              className={
                changeColor === '5' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='Freelancer' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#Request-section'
              onClick={() => {
                setChangeColor('6');
              }}
              className={
                changeColor === '6' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='Request' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#Services-section'
              onClick={() => {
                setChangeColor('7');
              }}
              className={
                changeColor === '7' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='Services' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#Privacy-section'
              onClick={() => {
                setChangeColor('8');
              }}
              className={
                changeColor === '8' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='Privacy Policy' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#Users-section'
              onClick={() => {
                setChangeColor('9');
              }}
              className={
                changeColor === '9' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='Users' />"
            </a>
            <p className={style.solid}></p>
            <a
              href='#APPLICABILITY-section'
              onClick={() => {
                setChangeColor('10');
              }}
              className={
                changeColor === '10' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='APPLICABILITY' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#MODIFICATIONS-section'
              onClick={() => {
                setChangeColor('11');
              }}
              className={
                changeColor === '11' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='MODIFICATIONS TO THE PRIVACY POLICY' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#APPLICABLE-section'
              onClick={() => {
                setChangeColor('12');
              }}
              className={
                changeColor === '12' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='APPLICABLE LEGISLATION' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#PERSONAL-section'
              onClick={() => {
                setChangeColor('13');
              }}
              className={
                changeColor === '13' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='PERSONAL DATA' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#PROVIDING-section'
              onClick={() => {
                setChangeColor('14');
              }}
              className={
                changeColor === '14' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='PROVIDING PERSONAL DATA AND INFORMATION' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#DATA-section'
              onClick={() => {
                setChangeColor('15');
              }}
              className={
                changeColor === '15' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='DATA COLLECTION AND PERMITTED DISCLOSURES' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#PERSONALUSAGE-section'
              onClick={() => {
                setChangeColor('16');
              }}
              className={
                changeColor === '16' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='PERSONAL DATA USAGE' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#NOTIFICATIONS-section'
              onClick={() => {
                setChangeColor('17');
              }}
              className={
                changeColor === '17' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='NOTIFICATIONS' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#COURT-section'
              onClick={() => {
                setChangeColor('18');
              }}
              className={
                changeColor === '18' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='COURT ORDERS AND LAWFUL DISCLOSURES' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#STORAGE-section'
              onClick={() => {
                setChangeColor('19');
              }}
              className={
                changeColor === '19' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='STORAGE AND VERIFICATIONS' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#CONFIDENTIALITY-section'
              onClick={() => {
                setChangeColor('20');
              }}
              className={
                changeColor === '20' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='CONFIDENTIALITY OF PERSONAL DATA' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#USERRIGHTS-section'
              onClick={() => {
                setChangeColor('21');
              }}
              className={
                changeColor === '21' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='USER RIGHTS' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#EXPLICIT-section'
              onClick={() => {
                setChangeColor('22');
              }}
              className={
                changeColor === '22' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='EXPLICIT CONSENTS' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#APP-section'
              onClick={() => {
                setChangeColor('23');
              }}
              className={
                changeColor === '23' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='APP AS AN INTERMEDIARY' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#TRANSFERS-section'
              onClick={() => {
                setChangeColor('24');
              }}
              className={
                changeColor === '24' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='TRANSFERS OF DATA' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#COOKIES-section'
              onClick={() => {
                setChangeColor('25');
              }}
              className={
                changeColor === '25' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='COOKIES' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#THIRDLINKS-section'
              onClick={() => {
                setChangeColor('26');
              }}
              className={
                changeColor === '26' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='THIRD PARTY LINKS' />
            </a>
            <p className={style.solid}></p>
            <a
              href='#QUESTIONS-section'
              onClick={() => {
                setChangeColor('27');
              }}
              className={
                changeColor === '27' ? style.onClicksideTitle : style.sideTitle
              }
            >
              <I18n t='QUESTIONS' />
            </a>
            <p className={style.solid}></p>
          </p>
        </div>
        {languageDirection !== 'rtl' && (
          <div className={style.middle}>
            {/* <div id="my-section">Coming soon</div>
                    <a href="#my-section">Jump to my-section</a> */}
          </div>
        )}
        <div
          className={
            languageDirection === 'rtl'
              ? style.rtlLanguage.concat(' ').concat(style.RightSide)
              : style.RightSide
          }
        >
          {/* <h1>Right</h1> */}
          <div
            id='disclaimer-section'
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.title)
                : style.title
            }
          >
            <I18n t='Last Updated on May 1, 2020' />:
          </div>
          <div className={style.flexArtical}>
            <div className={style.artical}>
              <I18n t='R Phonedo Call Centers Ltd a private limited company based in Jerusalem owns and manages a web application mobile application or application on other platforms and devices entitled Phonedo (collectively referred to as the “App”) The App connects users namely businesses to freelancers and allows businesses to purchase translation services from freelancers The present Privacy Policy (the “Privacy Policy”) sets forth the terms and policy concerning the usage handling and collection of personal information from and through the App All personal data provided by way of the App shall be handled stored and used in accordance with this Privacy Policy This Privacy Policy has been prepared in accordance with applicable privacy legislation including but not limited to the General Data Protection Regulation (the “GDPR”)' />
            </div>
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              1.
            </div>
            <div
              id='DEFINITIONS-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='DEFINITIONS' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='This Privacy Policy may be read in combination with the latest version of the Apps Terms and Conditions which is also published on the App for review The defined terms in this Privacy Policy correspond to the defined terms in the Apps Terms and Conditions and are as follows' />
          </div>
          <div
            id='Business-section'
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.title)
                : style.title
            }
          >
            <I18n t='Business' />:
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='shall refer to any business organization or entity that uses the App to place Requests and to obtain Services offered by Freelancers' />
          </div>
          <div
            id='Company-section'
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.title)
                : style.title
            }
          >
            <I18n t='Company' />:
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='shall refer to R Phonedo Call Centers Ltd a limited company having its registered offices located at 3 Bruchim Street Jerusalem 9530803 Israel The Company may also be referred to as “we” “us” “our” and other similar expressions' />
          </div>
          <div
            id='Freelancer-section'
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.title)
                : style.title
            }
          >
            <I18n t='Freelancer' />:
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='shall refer to any freelancer agent or service provider using the App to offer and provide Services' />
          </div>
          <div
            id='Request-section'
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.title)
                : style.title
            }
          >
            <I18n t='Request' />:
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='shall refer to any request for specific Services placed by the Business through the App The Request shall be placed according to the instructions detailed on the App and the purpose of the Request shall be to obtain Services from a qualified Freelancer' />
          </div>
          <div
            id='Services-section'
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.title)
                : style.title
            }
          >
            <I18n t='Services' />:
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='shall refer to the services offered by Freelancers on the App The Services shall include without limitation human phone answering services sales support and live translations in a variety of languages' />
          </div>
          <div
            id='Privacy-section'
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.title)
                : style.title
            }
          >
            <I18n t='Privacy Policy' />:
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='shall refer to the latest applicable version of the present Privacy Policy and includes any and all amendments and supplements made hereto from time to time' />
          </div>
          <div
            id='Users-section'
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.title)
                : style.title
            }
          >
            <I18n t='Users' />:
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='shall refer to all users of the App including the Businesses and the Freelancers Users may also be referred to as “you” “your” and other similar expressions in this Privacy Policy' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              2.
            </div>
            <div
              id='APPLICABILITY-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='APPLICABILITY' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='Any submission or provision of personal information on or though the App will be handled and governed in accordance with this Privacy Policy Any information collected by the Company as a result of the App shall also be governed by the terms of this Privacy Policy Upon downloading accessing or otherwise using the App you shall be deemed to have accepted the terms of this Privacy Policy in full As such any usage of the App signifies your acceptance of this Privacy Policy' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              3.
            </div>
            <div
              id='MODIFICATIONS-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='MODIFICATIONS TO THE PRIVACY POLICY' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='The Company may modify this Privacy Policy at any time at its discretion The modified Privacy Policy will be published on the App The modified Privacy Policy will be applicable to information collected on and through the App as of the date its publication on the App The date of the latest revision of this Privacy Policy shall be published for reference purposes' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              4.
            </div>
            <div
              id='APPLICABLE-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='APPLICABLE LEGISLATION' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='This Privacy Policy has been prepared and implemented in accordance with terms of the General Data Protection Regulation 2016/679 (the “GDPR”) The GDPR was enacted in April 2016 and came into force as of May 2018 The GDPR is applicable to residents based in both European Union (EU) and the European Economic Area (EEA) This legislation governs the collection usage and transfer of personal data One of the main purposes of the GDPR is to provide individuals with information regarding the usage collection and handling of their personal data in turn allowing for greater control and data management' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              5.
            </div>
            <div
              id='PERSONAL-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='PERSONAL DATA' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='Personal data is information regarding an identifiable individual also known as a natural person Personal data includes without limitation your name address credit card number and other information regarding a specific individual The GDPR defines personal data as follows “any information relating to an identified or identifiable natural person (‘data subject’) an identifiable natural person is one who can be identified directly or indirectly in particular by reference to an identifier such as a name an identification number location data an online identifier or to one or more factors specific to the physical physiological genetic mental economic cultural or social identity of that natural person” This definition of Personal data has been reproduced above in italics from the GDPR and is for information purposes In accordance with the requirements of the GDPR we shall only collect personal data that is provided voluntarily by you on the App We shall handle and manage such information in accordance with the terms of this Privacy Policy' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              6.
            </div>
            <div
              id='PROVIDING-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='PROVIDING PERSONAL DATA AND INFORMATION' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='There is no requirement to provide personal data or information to the Company upon downloading the App To benefit from Services offered on or by the App it may be necessary for you to provide us with personal information To create a user account on the App you will be required to submit some personal information More specifically to make purchase Services or to offer Services on the App you may also be required to provide personal data and information You are not required to provide personal information to us however please keep in mind that you will not be able to provide Services or purchase Services if you have not provided the necessary personal information We will only collect personal data and information that you provide voluntarily on the App You understand that we may be able to collect information that is not personal to you such as preferences browsing history or other information that is tracked by way of cookies or though other means This type of information will not allow for your personal identification Moreover when you engage in discussions phone calls or Services with other Users on the App you acknowledge that we will be granted unrestricted access to the content of the discussions phone calls and Services We will use this content to assess the Services for internal compliance and to ensure there is no fraud on the App The reasons for which we collect information are further detailed in this Privacy Policy' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              7.
            </div>
            <div
              id='DATA-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='DATA COLLECTION AND PERMITTED DISCLOSURES' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='We hereby confirm that the collection and handling of personal data will be fully compliant with applicable laws and regulations applicable to the collection safeguard handling and protection of personal data To ensure that personal information obtained from the App is thoroughly protected and safeguarded we established appropriate measures and procedures These measures and procedures are destined to protect the personal data you provide to us on or through the App All personal data you provide shall be subject to the procedures and measures we established As such we shall not share transmit or otherwise disclose personal data to our employees directors and affiliates unless they have a compelling and justified need to know such information If such cases the disclosure of the personal information shall be limited to the information strictly required for purposes of the App The disclosure of personal data shall further be limited for a specific predetermined purpose and for no other purpose Further we shall ensure that any third party who is granted access to personal data complies with the confidentiality obligations contained in this Privacy Policy' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              8.
            </div>
            <div
              id='PERSONALUSAGE-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='PERSONAL DATA USAGE' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='We shall use the personal data you provide on the App to fulfill the purpose for which you provided the information and according to this Privacy Policy The usage of the personal information shall be limited to the extent required by our legitimate business interests and based on the requirements of the GDPR We shall be authorized to use the personal data you provide to fulfill the following general purposes: – to fulfill the purpose of the App; – to allow you to offer and provide Services on the App; – to allow you to purchase Services and submit Requests to secure a Freelancer; – to respond to a valid court, government directive or applicable legislation; – if the usage of the personal information relates to the public domain or is of public interest; – to respond to a Request submitted in the manner and to the extent explicitly authorized by the User providing such personal information; – in accordance with your explicit consent for a predetermined purpose By providing personal information through the App you acknowledge and agree that we may use your personal information in the accordance with the following specific purposes: – to provide recommendations options and corresponding information on the App; – to offer promotions with respect to the Services or to the App; – to inform you of Services or products that may be of interest; – to communicate with you regarding the Services opportunities, issues, Requests and other matters relating to the App; – to respond to questions information requests inquiries and all other claims transmitted in connection with the App; – to assess the App’s features compatibility, preferences, and suitability; – to assess and improve the Services and other features offered on the App; – to control the effectiveness of the Services to perform spot checks and to assess suitability; – to retain copies of conversations phone calls and discussions held through the App for quality control and archiving purposes; – to ensure compliance with court orders and applicable legal provisions In accordance with the data minimization obligation set forth in the GDPR we undertake to limit all usage of your personal information to that which is strictly necessary to satisfy the purpose of the data usage We will not use the personal data in a way that is unreasonable or excessive to fulfill the purpose of its collection and usage however we do reserve the right to share information with selected third parties in furtherance of the App its development or for any reason deemed appropriate by us at our discretion' />
          </div>

          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              9.
            </div>
            <div
              id='NOTIFICATIONS-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='NOTIFICATIONS' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='You have the right to send us a request to unsubscribe or no longer receive written communications or notices in connection with the App This request may be sent by email or by adjusting settings on the App You may also disable email notifications from us by changing the settings in your user account and on the App following the instructions applicable to unsubscribing from email notifications' />
          </div>

          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              10.
            </div>
            <div
              id='COURT-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='COURT ORDERS AND LAWFUL DISCLOSURES' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='As mentioned in this Privacy Policy we shall be authorized to communicate and disclose personal information if required to do so under a valid court order or by a legal obligation We shall communicate and disclose all necessary personal data to ensure compliance with applicable laws and regulations In such cases we may disclose the personal data without informing you prior to the disclosure Any disclosure of personal information pursuant to a court order or legal obligation shall be limited to the personal data directly relevant to the legal obligation and shall not require your prior consent We agree communicate and disclose personal information further to a valid court order Such personal data shall be disclosed in accordance with the instructions set forth in the court order Insofar as reasonably practicable we shall notify you upon our receipt of the court order and corresponding obligation to disclose If you are notified in advance, this shall allow you to seek a protective order or other legal remedy to maintain such information in confidence' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              11.
            </div>
            <div
              id='STORAGE-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='STORAGE AND VERIFICATIONS' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='The personal data collected on the App shall be held and stored in our files and/or servers We undertake to verify and ensure that the personal data held in our files is correct accurate and updated We will correct or delete any personal information that is false incomplete unusable or otherwise inaccurate You can send us a notification to request for the correction deletion or destruction of your personal data if it is incorrect incomplete unusable or otherwise inaccurate Your personal information will remain in our servers for the duration that is necessary based on the purpose the applicable legislation and the authorization you provided if applicable We may hold your personal data for a longer period if it is preferable to do so due to public interest or for reasons exceeding our control such as government orders or valid third party requests We shall not store personal data on file for an excessive or unreasonable duration' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              12.
            </div>
            <div
              id='CONFIDENTIALITY-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='CONFIDENTIALITY OF PERSONAL DATA' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='We shall apply and enforce all necessary measures to protect the confidentiality of your personal data As such we shall not disclose your personal information to any third party except in accordance with this Privacy Policy We shall apply all reasonable measures to protect your personal data from unauthorized disclosure damages or other breaches These confidentiality obligations shall apply regardless of whether your personal information is stored or currently used for purposes of the App' />
          </div>

          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              13.
            </div>
            <div
              id='USERRIGHTS-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='USER RIGHTS' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='We shall grant you the rights provided to personal data providers under the GDPR If you submit personal data on the App you will be permitted to exercise rights in connection to the personal data submitted You have the right to access the personal data you submitted on the App To gain access to the personal data submitted please send us a request Your request should contain the extent of the personal data requested and the timeframe for which the request applies We will carefully review your request and we will submit the information requested if reasonable to do so You further have the right to obtain information regarding our usage of your personal data While our usage of your personal data will comply with the terms of this Privacy Policy you may request further explanations or details If you wish to exercise this right please submit a request to our attention As specified in this Privacy Policy you can request for us to correct and rectify any incorrect erroneous unusable or otherwise false personal data Upon our receipt of your request we will investigate this matter If the information is indeed incorrect or false we will promptly correct or delete the problematic information from your file If you would like for your personal data to be deleted from our servers please send us a request We will agree to remove your personal data from our servers if reasonable to do so We may also delete personal information from our servers if we consider such information to be unnecessary damageable or otherwise problematic' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              14.
            </div>
            <div
              id='EXPLICIT-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='EXPLICIT CONSENTS' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='You may provide us with an explicit consent to use your personal data for a purpose that is not specified in this Privacy Policy Your explicit consent must be provided in writing and must state the reasons for which you would like your personal data used Your explicit consent must be validly transmitted to us through the App or by email We shall then be authorized to use your personal data for the purpose detailed in your explicit consent If there is no time limit indicated in your consent we will consider that such consent is for an unlimited duration' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              15.
            </div>
            <div
              id='APP-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='APP AS AN INTERMEDIARY' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='The App operates as an intermediary between Users allowing for the provision and purchase of Services You acknowledge that we have certain contractual obligations with respect to the services offered on the App As such to process and carry out a transaction between Users we may require a Business’ payment information To compensate a Freelancer for the Services performed we may need to gain access to the Freelancer’s bank account information It may be necessary for us to collect personal information to fulfill its contractual obligations in connection with the App' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              16.
            </div>
            <div
              id='TRANSFERS-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='TRANSFERS OF DATA' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='We shall not transfer any personal data collected from on or through the App outside of the European Union except if the transfer complies with the conditions specified in the GDPR The GDPR authorizes for data transfers beyond the European Union only with those countries that abide by strict data protection laws and regulations The United States is deemed to comply with such data protection legislation In consideration thereof we may transfer your personal data to servers located in the United States' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              17.
            </div>
            <div
              id='COOKIES-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='COOKIES' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='Cookies consist of small data files installed onto your device upon the Users visit to a particular app or website We reserve the right to use cookies in connection with the App or any corresponding website Cookies shall allow us to identify your device prevent hacking and unauthorized usage Cookies shall further allows us to provide you with a customized experience on our App and corresponding websites You may disable the usage of cookies by adjusting settings or turning the cookies option off Some portions of the App or the corresponding website may be unusable if cookies are disabled' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              18.
            </div>
            <div
              id='THIRDLINKS-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='THIRD PARTY LINKS' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='The present Privacy Policy is applicable solely to the App and does not apply to any third party links ads websites or applications The App may provide links or reference to such third party links ads websites or applications The links provided are for reference and information purposes only and do not bind or otherwise implicate us We shall not be responsible for the usage and collection of personal data by third party websites or applications' />
          </div>
          <div className={style.flex}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              19.
            </div>
            <div
              id='QUESTIONS-section'
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t='QUESTIONS' />
            </div>
          </div>
          <div className={`${style.artical} ${style.flexArtical}`}>
            <I18n t='If you have any questions regarding this Privacy Policy please submit them to our attention by email or on the App We will do our best to respond quickly and thoroughly' />
          </div>
        </div>
      </div>
      <div id='section11' className={style.section11}>
        <img className={style.buttom} src={buttom} alt={buttom} />
        <img
          className={style.buttomMedia}
          src={buttomMedia}
          alt={buttomMedia}
        />
        <div className={style.rapper1}>
          <div className={style.header1}>
            <I18n t='Create better experiences with Phonedo Mobile app' />
          </div>
          <button
            className={style.smallButton1}
            onClick={() => {
              new Cookies().set('phone.do_cookies', true);
              history.push(
                `/${window.location.pathname.slice(1, 3)}/registration/verify-phone/`,
              );
            }}
          >
            <I18n t="Let's Do it!" />
          </button>
        </div>
      </div>
      <a
        className={style.whatsApp}
        href='Https://wa.me/97239125800?text'
        target='_blank'
        rel='noreferrer'
      >
        {' '}
        <img className={style.imgwhatsApp} src={whatsApp} alt={whatsApp} />{' '}
      </a>
    </div>
  );
};
